import { forwardRef, type InputHTMLAttributes } from 'react'
import { cn } from '#lib/utils'

export type InputSize = 'sm' | 'md'

const sizeClass: Record<InputSize, string> = {
  sm: 'h-8 px-2 text-xs',
  md: 'h-9 px-3 text-sm'
}

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  inputSize?: InputSize
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { inputSize = 'md', className, ...props },
  ref
) {
  return (
    <input
      ref={ref}
      className={cn(
        'min-w-0 select-text rounded-md border border-control-border bg-background text-foreground caret-foreground outline-none transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:border-ring aria-invalid:border-destructive aria-invalid:focus-visible:border-destructive disabled:cursor-not-allowed disabled:opacity-50',
        sizeClass[inputSize],
        className
      )}
      {...props}
    />
  )
})
